import React, { Fragment } from 'react'
import { connect } from 'react-redux'
import { CustomerSegment } from 'constants/dealConstants'
import CHAT_IMG from './chat.svg'
import SuccessLander from 'components/SuccessLander'
import { track } from 'utils/trackingUtils'
import './style.css'

const HEADER_TEXT = 'Ready to build your first bot?'
const BUTTON_TEXT = 'Let’s go!'

const OnboardingPlaybookReadyStep = ({ onContinue, history, name, path, segment }) => {
  const SUBHEADER_TEXT = (segment === CustomerSegment.SMB) || (segment === CustomerSegment.VSB) ?
    <Fragment>Just answer a few questions to build your first bot in minutes!</Fragment> :
    <Fragment>Just answer a few questions to build your first bot in minutes!<br/>Later on, your Customer Success Manager will help you build more advanced bots.</Fragment>

  function onPlaybookClick() {
    track(`${name} Step - Continued`, { skipped: false, route: '/ready', segment: segment })
    history.push('/onboarding/playbook')
  }

  return (
    <Fragment>
      <SuccessLander
        className="playbook-ready-success-lander"
        image={CHAT_IMG}
        headerText={HEADER_TEXT}
        buttonText={BUTTON_TEXT}
        onButtonClick={onPlaybookClick}
        subheaderText={SUBHEADER_TEXT}
      />
      <a className="playbook-ready-skip" onClick={onContinue}>
        No thanks
      </a>
    </Fragment>
  )
}

export default connect(null)(OnboardingPlaybookReadyStep)


// WEBPACK FOOTER //
// ./src/layouts/OnboardingPlaybookReadyStep/index.js